<div class="kyc-verification-component">

  <div class="row separator">
    <div class="col-md-12 individuals-header" fxLayout="row" fxLayoutAlign="space-between center"
      fxLayout.lt-md="column" fxLayoutAlign.lt-md="start start">
      <div class="mat-h3">Individuals</div>
      <div class="header w-lt-md-100" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="end center"
        fxLayout.lt-md="column" fxLayoutAlign.lt-md="center start">
        @if (isInternalUser(loggedInUser)) {
        <button mat-flat-button class="inactive w-lt-md-100" (click)="onAddGuarantor()"
          [disabled]="disableAddGuarantor()" [matTooltip]="addGuarantorTooltip()"><span class="mdi mdi-plus"
            matPrefix></span>Add Guarantor</button>
        }
        <button mat-flat-button color="primary" class="active w-lt-md-100" (click)="saveAll()"
          [disabled]="disableSaveAll()" matTooltip="Save all changes"><span class="mdi mdi-check"
            matPrefix></span>Save</button>
        <button mat-flat-button class="inactive w-lt-md-100" (click)="refresh()"><span class="mdi mdi-refresh"
            matPrefix></span></button>
      </div>
    </div>
  </div>

  <mat-card appearance="outlined" id="individuals-review">
    <mat-card-content class="px-0">
      @if (!individualsLoaded) {
      <div class="section-loading">
        <mat-spinner [diameter]="26" [strokeWidth]="2"></mat-spinner>
        <span>Loading individuals...</span>
      </div>
      } @else {
      <div class="row">
        <div class="col-12 individual-details-section">
          <table mat-table class="individuals-table" [dataSource]="dataSource" multiTemplateDataRows>
            <ng-container matColumnDef="dir">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element" class="cell cell-padding">
                @if (!canExpand(element)) {
                <span class="mdi mdi-pencil-outline" matTooltip="Click the row to complete missing details"></span>
                } @else if (isTableRowExpanded(element)) {
                <span class="mdi mdi-chevron-up"></span>
                } @else {
                <span class="mdi mdi-chevron-down"></span>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="firstName">
              <th mat-header-cell *matHeaderCellDef>Name</th>
              <td mat-cell *matCellDef="let element" class="cell ellipsis"
                matTooltip="{{displayName(element)}}">{{displayName(element)}}
                @if (isProvisionalIndividual(element)) {
                <tag-box [state]="'New — unsaved'"></tag-box>
                }
                @if(element.isPrimaryContact){ <tr>
                  <tag-box [state]="'Primary Contact'"></tag-box>
                </tr>
                }
                @if (isInternalUser(loggedInUser) && requiresPartyRelationshipReview(element)) {
                <div class="party-review-required"
                  matTooltip="This individual has no active party relationship. Review and delete manually if no longer required.">
                  <span class="mdi mdi-alert-circle-outline"></span> Internal review required
                </div>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="dob">
              <th mat-header-cell *matHeaderCellDef>Date of Birth</th>
              <td mat-cell *matCellDef="let element" class="cell">{{displayDob(element)}}</td>
            </ng-container>
            <ng-container matColumnDef="signerRole">
              <th mat-header-cell *matHeaderCellDef>Signer Role</th>
              <td mat-cell *matCellDef="let element" class="cell">{{displaySignerRole(element) | signerRole}}</td>
            </ng-container>
            <ng-container matColumnDef="riskScore">
              <th mat-header-cell *matHeaderCellDef>Risk Score</th>
              <td mat-cell *matCellDef="let element" class="cell">
                @if (riskScore(element) !== null) {
                {{riskScore(element)}}
                } @else {
                <span class="not-available" matTooltip="No risk score available">&mdash;</span>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="riskRating">
              <th mat-header-cell *matHeaderCellDef>Risk Rating</th>
              <td mat-cell *matCellDef="let element" class="cell">
                @if (riskRating(element); as rating) {
                <span class="risk-rating {{riskRatingClass(element)}}">{{rating}}</span>
                } @else {
                <span class="not-available" matTooltip="No risk rating available">&mdash;</span>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let element" class="cell">
                @if (isStatusOk(element)) {
                <span class="mdi mdi-check-circle-outline ok" matTooltip="Verification successful"></span>
                }
                @if (isStatusPendingReview(element)) {
                <span class="mdi mdi-progress-alert pending-review" matTooltip="Under review"></span>
                }
                @if (isStatusIncomplete(element)) {
                <span class="mdi mdi-progress-question incomplete" matTooltip="Verification incomplete"></span>
                }
                @if (isStatusFailed(element)) {
                <span class="mdi mdi-alert-circle-outline error" matTooltip="KYC verification failed"></span>
                }
                @if (isStatusSmsSent(element)) {
                <span class="mdi mdi-timer-sand waiting"
                  matTooltip="Verification SMS sent"></span>
                }
                @if (isStatusError(element)) {
                <span class="mdi mdi-alert-circle-outline error" matTooltip="System error"></span>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="consentStatus">
              <th mat-header-cell *matHeaderCellDef>Consent</th>
              <td mat-cell *matCellDef="let element" class="cell">
                <span class="mdi consent-status-icon {{consentStatusIcon(element)}} {{consentStatusIconClass(element)}}"
                  [matTooltip]="consentStatusTooltip(element)" matTooltipPosition="below"></span>
              </td>
            </ng-container>
            <ng-container matColumnDef="edited">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element" class="cell">
                @if (needsAttention(element)) {
                <span class="mdi mdi-alert-circle-outline needs-attention"
                  [matTooltip]="needsAttentionTooltip(element)"></span>
                } @else if (hasUnsavedEdits(element)) {
                <span class="mdi mdi-pencil edited-unsaved" matTooltip="Edited - not saved yet"></span>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element" class="cell">
                @if (isInternalUser(loggedInUser)) {
                <span class="mdi mdi-dots-vertical cursor-pointer" (click)="$event.stopPropagation();"
                  [matMenuTriggerFor]="menu"></span>
                }
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="editIndividual(element)" class="pr-0">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                      <div class="pr-2">Edit</div>
                      <div><span class="mdi mdi-pencil-outline"></span></div>
                    </div>
                  </button>
                  <mat-divider></mat-divider>
                  <button mat-menu-item (click)="deleteIndividual($event, element)" class="pr-0">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                      <div>Delete</div>
                      <div><span class="mdi mdi-trash-can-outline"></span></div>
                    </div>
                  </button>
                  @if (canMergeIndividuals) {
                  <mat-divider></mat-divider>
                  <button mat-menu-item (click)="onMergeInto(element)" class="pr-0">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                      <div class="pr-2">Merge</div>
                      <div><span class="mdi mdi-call-merge"></span></div>
                    </div>
                  </button>
                  }
                  <mat-divider></mat-divider>
                  <button mat-menu-item (click)="onPrimaryContact(element)" class="pr-0"
                    [disabled]="element.isPrimaryContact">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                      <div class="pr-2">Primary contact</div>
                    </div>
                  </button>
                </mat-menu>
              </td>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
              <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
                <div class="element-detail" [@detailExpand]="isTableRowExpanded(element) ? 'expanded' : 'collapsed'">
                  @if (isInternalUser(loggedInUser)) {
                  @for (review of applicationReconciliationReviews(element); track review.entity.commercialEntityId) {
                  <div class="application-reconciliation-review" (click)="$event.stopPropagation()">
                    <div class="application-reconciliation-heading">
                      <span class="mdi mdi-alert-circle-outline"></span>
                      KYB reconciliation · {{ review.entity.entityName }}
                    </div>
                    <div class="application-reconciliation-copy">
                      This individual was not returned by KYB. Choose whether to keep them on the
                      application or remove them when you save.
                    </div>
                    <div class="application-reconciliation-actions">
                      <button type="button" mat-stroked-button
                        [class.selected]="review.decision === 'KEEP'"
                        (click)="stageApplicationReconciliationDecision($event, review, 'KEEP')">
                        Keep individual
                      </button>
                      <button type="button" mat-stroked-button
                        [class.selected]="review.decision === 'REMOVE'"
                        (click)="stageApplicationReconciliationDecision($event, review, 'REMOVE')">
                        Remove individual
                      </button>
                      @if (review.decision) {
                      <span class="application-reconciliation-staged">
                        {{ review.decision === 'KEEP' ? 'Keep' : 'Remove' }} staged
                      </span>
                      }
                    </div>
                    @if (review.error) {
                    <div class="application-reconciliation-error">{{ review.error }}</div>
                    }
                  </div>
                  }
                  }
                  @if (individualFormGroup(element)) {
                  <div class="">
                    @if (duplicatedEmailOrMobile(element)) {
                    <div class="row separator-bottom">
                      <div class="col">
                        <message-box type="warn">
                          <p>The email & mobile should be unique</p>
                        </message-box>
                      </div>
                    </div>
                    }
                    <div class="row">
                      <div class="col-12">
                        <div fxLayout="row" fxLayoutAlign="space-between start" fxLayout.lt-md="column"
                          fxLayoutAlign.lt-md="center start">
                          <div>
                            <div class="mat-h3 ellipsis individual-name"
                              matTooltip="{{displayHeaderName(element)}} - {{displaySignerRole(element) | signerRole}}">{{displayHeaderName(element)}}
                              - {{displaySignerRole(element) | signerRole}}</div>
                          </div>
                          <div class="w-lt-md-100" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-md="column"
                            fxLayoutAlign.lt-md="center start">
                            @if (isInternalUser(loggedInUser)) {
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row separator individual-summary">
                      @for (field of individualSummary(element); track field.label) {
                      <div class="individual-summary-item"
                        [ngClass]="field.full ? 'col-12' : 'col-lg-4 col-md-6'">
                        <div class="mat-caption">{{field.label}}</div>
                        <div class="mat-body">{{field.value}}</div>
                      </div>
                      }
                    </div>
                    @if (showVerificationDetails(element)) {
                    <kyc-verification-details
                      [result]="element.result"
                      [history]="element.result?.history"
                      [isExpanded]="isVerificationResultExpanded(element)"
                      [showSyncFromFrankieOneButton]="canUpdateKycStatus() && !!syncIndividualKycFromFrankieOneFn"
                      [syncInProgress]="!!(loader.syncKycFromFrankieOne.inProgress$ | async)"
                      [showUpdateKycButton]="canUpdateKycStatus()"
                      [showFrankieOneButton]="canUpdateKycStatus()"
                      [showIssues]="isInternalUser(loggedInUser)"
                      [showSendSmsButton]="isInternalUser(loggedInUser)"
                      [sendSmsDisabled]="isKycSmsDisabled(element) || !!(loader.sendVerificationSms.inProgress$ | async)"
                      [sendSmsTooltip]="kycSmsDisabledTooltip(element)"
                      [sendSmsInProgress]="!!(loader.sendVerificationSms.inProgress$ | async)"
                      (toggleExpand)="toggleVerificationResult(element)"
                      (syncFromFrankieOne)="syncKycFromFrankieOne(element)"
                      (updateKyc)="manualVerify(element)"
                      (sendSms)="_sendVerificationSmsToIndividual(element)">
                    </kyc-verification-details>
                    }
                    <div class="verification-details-container">
                      <div class="details-header" style="cursor: default;">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" style="flex: 1;">
                          <span class="mdi mdi-shield-check-outline"></span>
                          <div class="header-title-group">
                            <span class="header-title">Privacy Consent</span>
                          </div>
                        </div>
                        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="end center">
                          @if (canBypassConsent(element)) {
                          <button mat-stroked-button (click)="bypassConsent(element)">
                            <span class="mdi mdi-shield-check mr-2"></span>
                            Mark Consent Complete
                          </button>
                          }
                          @if (isInternalUser(loggedInUser) && element.guid) {
                          <span
                            [matTooltip]="consentDispatchDisabledTooltip(element)"
                            [matTooltipDisabled]="!consentDispatchDisabledTooltip(element)">
                            <button mat-stroked-button
                              (click)="dispatchConsentForm(element)"
                              [disabled]="disableConsentDispatch(element)">
                              <span class="mdi mdi-email-send-outline mr-2"></span>
                              {{ consentDispatchButtonLabel(element) }}
                            </button>
                          </span>
                          }
                        </div>
                      </div>

                      <div class="details-content">
                        @if (!(element.privacyConsent && element.privacyConsent.length)) {
                        <div class="row">
                          <div class="col-lg-9 col-md-12">
                            <message-box type="info">
                              <p>No privacy consent records yet</p>
                            </message-box>
                          </div>
                        </div>
                        }
                        @if (consentDispatchFailed(element.privacyConsent)) {
                        <div class="row">
                          <div class="col-lg-9 col-md-12">
                            <message-box type="danger">
                              <p><strong>Consent Dispatch Failed &ndash; Action Required.</strong> {{consentDispatchFailureReason(element.privacyConsent)}}. Please complete this individual's contact details and resend the consent form.</p>
                            </message-box>
                          </div>
                        </div>
                        }
                        @if (manuallyCompletedConsent(element); as manualCompletion) {
                        <div class="row">
                          <div class="col-lg-9 col-md-12">
                            <message-box type="warn">
                              <p><strong>Manually Completed.</strong> Privacy consent was recorded as complete by
                                {{manualCompletion.by}} on {{manualCompletion.when | date:'dd/MM/yyyy h:mm a'}} without a
                                customer signature. Reason: {{manualCompletion.reason}}</p>
                            </message-box>
                          </div>
                        </div>
                        }
                        @if (element.privacyConsent && element.privacyConsent.length) {
                        <div class="row">
                          <div class="col-md-12">
                            <table mat-table [dataSource]="element.privacyConsent" multiTemplateDataRows>
                              <ng-container matColumnDef="userId">
                                <th mat-header-cell *matHeaderCellDef>Sent By</th>
                                <td mat-cell *matCellDef="let privacyConsentElement" class="cell cell-padding">
                                  {{privacyConsentElement.GivenName ?? ''}} {{privacyConsentElement.FamilyName ?? ''}}
                                </td>
                              </ng-container>
                              <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef>Status</th>
                                <td mat-cell *matCellDef="let privacyConsentElement" class="cell cell-padding"
                                  [matTooltip]="consentRecordTooltip(privacyConsentElement)"
                                  [matTooltipDisabled]="!consentRecordTooltip(privacyConsentElement)">
                                  <privacy-consent-status-chip
                                    [status]="consentStatusLabel(privacyConsentElement)"
                                    [styleKey]="consentStatusStyleKey(privacyConsentElement)"></privacy-consent-status-chip>
                                </td>
                              </ng-container>
                              <ng-container matColumnDef="createdTime">
                                <th mat-header-cell *matHeaderCellDef>Sent Time</th>
                                <td mat-cell *matCellDef="let privacyConsentElement" class="cell cell-padding">
                                  {{privacyConsentElement.createdTime | date:'dd/MM/yyyy h:mm:ss a'}}
                                </td>
                              </ng-container>
                              <ng-container matColumnDef="statusChanged">
                                <th mat-header-cell *matHeaderCellDef>Status Changed</th>
                                <td mat-cell *matCellDef="let privacyConsentElement" class="cell cell-padding">
                                  {{consentStatusChanged(privacyConsentElement) | date:'dd/MM/yyyy h:mm:ss a'}}
                                </td>
                              </ng-container>
                              <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let privacyConsentElement" class="cell cell-padding">
                                  @if (showReissueConsentButton(element, privacyConsentElement)) {
                                  <button mat-icon-button color="primary" matTooltip="Re-issue consent form" (click)="reissueConsent(element)">
                                    <span class="mdi mdi-refresh"></span>
                                  </button>
                                  }
                                </td>
                              </ng-container>
                              <tr mat-header-row *matHeaderRowDef="['userId', 'status', 'createdTime', 'statusChanged', 'action']">
                              </tr>
                              <tr mat-row
                                *matRowDef="let privacyConsentElement; columns: ['userId', 'status', 'createdTime', 'statusChanged', 'action']"
                                class="example-element-row"
                                [ngClass]="{'consent-historical': isHistoricalConsent(privacyConsentElement)}"></tr>
                            </table>
                          </div>
                        </div>
                        }
                      </div>
                    </div>
                    @if (element.identityVerificationResult) {
                    <mat-divider [inset]="true" class="mb-3"></mat-divider>
                    <div class="row separator">
                      <div class="col-md-12">
                        <div fxLayout="row" fxLayoutAlign="space-between start" fxLayout.lt-md="column"
                          fxLayoutAlign.lt-md="center start">
                          <div class="mb-3">
                            <div class="mat-h3">Identity Facial Recognition</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row separator">
                      <div class="col-lg-6 col-md-12">
                        <div class="id-verify-item" fxLayout="row" fxLayoutAlign="space-between center">
                          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <div><span class="mdi mdi-calendar-clock"></span></div>
                            <div>Verification Time</div>
                          </div>
                          <div>{{element?.identityVerificationResult?.identityVerificationTime | date : 'dd/MM/yyyy h:mm
                            a'}}</div>
                        </div>
                        <div class="id-verify-item" fxLayout="row" fxLayoutAlign="space-between center">
                          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <div><span class="mdi mdi-face-recognition"></span></div>
                            <div>Liveness Confidence</div>
                          </div>
                          <div>{{element?.identityVerificationResult?.livenessConfidence}}</div>
                        </div>
                        <div class="id-verify-item" fxLayout="row" fxLayoutAlign="space-between center">
                          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <div><span class="mdi mdi-select-compare"></span></div>
                            <div>Face Compare Score</div>
                          </div>
                          <div>{{element?.identityVerificationResult?.faceCompareScore?.toFixed(5)}}</div>
                        </div>
                        @if (element?.identityVerificationResult?.passLivenessTest) {
                        <div class="id-verify-success-item" fxLayout="row" fxLayoutAlign="start center"
                          fxLayoutGap="10px">
                          <div><span class="mdi mdi-check-decagram"></span></div>
                          <div>Passed Liveness Test</div>
                        </div>
                        }
                        @if (!element?.identityVerificationResult?.passLivenessTest) {
                        <div class="id-verify-warning-item" fxLayout="row" fxLayoutAlign="start center"
                          fxLayoutGap="10px">
                          <div><span class="mdi mdi-alert-box-outline"></span></div>
                          <div>Not Passed Liveness Test</div>
                        </div>
                        }
                        @if (element?.identityVerificationResult?.passFaceCompare) {
                        <div class="id-verify-success-item" fxLayout="row" fxLayoutAlign="start center"
                          fxLayoutGap="10px">
                          <div><span class="mdi mdi-check-decagram"></span></div>
                          <div>Passed Face Compare</div>
                        </div>
                        @if (element?.identityVerificationResult?.lastUpdatedBy) {
                        <div class="id-verify-item" fxLayout="row" fxLayoutAlign="space-between center">
                          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <div><span class="mdi mdi-alert-box-outline"></span></div>
                            <div>Bypassed by {{element?.identityVerificationResult?.lastUpdatedGivenName ?? ''}}
                              {{element?.identityVerificationResult?.lastUpdatedFamilyName ?? ''}}</div>
                          </div>
                          <div>{{element?.identityVerificationResult?.lastUpdatedTime | date : 'dd/MM/yyyy h:mm a'}}
                          </div>
                        </div>
                        }
                        }
                        @if (!element?.identityVerificationResult?.passFaceCompare) {
                        <div class="id-verify-warning-item" fxLayout="row" fxLayoutAlign="start center"
                          fxLayoutGap="10px">
                          <div><span class="mdi mdi-alert-box-outline"></span></div>
                          <div>Not Passed Face Compare</div>
                        </div>
                        }
                      </div>
                      @if (livenessPicture || driverLicence) {
                      <div class="col-lg-6 col-md-12">
                        @if (livenessPicture) {
                        <div class="mb-3">
                          <div class="mat-caption">Liveness Picture</div>
                          <image-with-bounding-box
                            [src]="livenessPicture"
                            [text]="'Liveness Picture'"
                            [boundingBoxes]="getLivenessPictureBoundingBoxes(element)">
                          </image-with-bounding-box>
                        </div>
                        }
                        @if (driverLicence) {
                        <div class="mb-3">
                          <div class="mat-caption">Driver's License</div>
                          <image-with-bounding-box
                            [src]="driverLicence"
                            [text]="'Driver License'"
                            [boundingBoxes]="getDriverLicenceBoundingBoxes(element)">
                          </image-with-bounding-box>
                        </div>
                        }
                      </div>
                      }
                    </div>
                    }
                  </div>
                  }
                </div>
              </td>
            </ng-container>

            <tr mat-header-row class="individuals-header-row" *matHeaderRowDef="columnsToDisplay"></tr>
            <tr mat-row *matRowDef="let element; columns: columnsToDisplay" class="cursor-pointer"
              [class.expanded-row]="isTableRowExpanded(element)"
              [class.provisional-row]="isProvisionalIndividual(element)"
              [class.needs-attention-row]="needsAttention(element)"
              [class.application-reconciliation-row]="isInternalUser(loggedInUser) && applicationReconciliationReviews(element).length > 0"
              (click)="expandTableRow(element)"></tr>
            <tr class="detail-row" [ngClass]="{'detail-row-expanded': isTableRowExpanded(element)}"
              [ngStyle]="{'display': isTableRowExpanded(element) ? null : 'none'}" mat-row
              *matRowDef="let element; columns: ['expandedDetail']"></tr>
          </table>
        </div>
      </div>
      }
    </mat-card-content>
  </mat-card>

  <kyb-entity-summary [applicationId]="application.ApplicationId"
    [canEdit]="isInternalUser(loggedInUser)"
    [canRunWorkflow]="canRunKybWorkflow()"
    [canReevaluateRisk]="isInternalUser(loggedInUser)"
    [partyStructureLocked]="partyStructureLocked()"
    [placesSearchResultFn]="placesSearchResultFn"
    [placesDetailsFn]="placesDetailsFn"
    (addParty)="onAddParty($event)"
    (addIndividualParty)="onAddIndividualParty($event)"
    (removeParty)="onRemoveParty($event)"
    (undoRemoveParty)="onUndoRemoveParty($event)"
    (removeIndividualParty)="onRemoveIndividualParty($event)"
    (keyPersonDetailsRequired)="onKeyPersonDetailsRequired($event)"
    (personResolutionUndo)="onUndoKybPersonResolution($event)"></kyb-entity-summary>
</div>
